import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'components/ui/checkbox/Checkbox';

const RenderCheckBoxInputField = (props) => {
    const {
        checkedIcon,
        disabled,
        input: { onChange, value },
        label,
        meta: { error, touched },
        uncheckedIcon,
        style,
    } = props;

    return (
        <div style={ style }>
            <Checkbox
                checked={ value ? true : false }
                checkedIcon={ checkedIcon }
                disabled={ disabled }
                label={ label }
                onCheck={ onChange }
                style={ style }
                uncheckedIcon={ uncheckedIcon }
            />

            { (touched && error) &&
                <div style={ {
                    color: 'red',
                    fontStyle: 'italic',
                    margin: '5px 0 0 40px',
                } }>
                    { error }
                </div>
            }
        </div>
    );
};

RenderCheckBoxInputField.propTypes = {
    checkedIcon: PropTypes.element,
    disabled: PropTypes.bool,
    input: PropTypes.shape({
        name: PropTypes.string,
        onBlur: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        onDragStart: PropTypes.func.isRequired,
        onDrop: PropTypes.func.isRequired,
        onFocus: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.string,
        ]),
    }).isRequired,
    label: PropTypes.string.isRequired,
    meta: PropTypes.shape({
        error: PropTypes.string,
        touched: PropTypes.bool,
    }),
    style: PropTypes.object,
    uncheckedIcon: PropTypes.element,
};

export default RenderCheckBoxInputField;



// WEBPACK FOOTER //
// ./src/components/form/InputFields/RenderCheckBoxInputField.js